import {createResource, getResource} from "./common"

export type Partner = {
	type: "partner"
	id: string
	attributes: {
		createdAt: Date
		name: string
	}
}

export type PartnerOnBehalfToken = {
	type: "onBehalfToken"
	attributes: {
		token: string
		expiresIn: number
	}
}

export async function findPartners(accessToken: string) {
	const result = await getResource<Array<Partner>>("partners", accessToken)
	return result.map((v) => v.data)
}

export async function createOnBehalfToken(accessToken: string, orgId: string) {
	const data = {
		type: "createOnBehalfToken",
		attributes: {
			orgId,
			scopes: "",
		},
	}

	return await createResource<PartnerOnBehalfToken>("partners/token", accessToken, data)
}
